import { Box, Button, Card, Grid, IconButton, Modal, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import moment from "moment";
import EditIcon from "@mui/icons-material/Edit";
import { useState, useEffect } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import {
  handleError,
  errorToast
} from "../../services/serviceBase";
import PageHeader from "./PageHeader";
import CustomInput from "./CustomInput";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import QrCode2Icon from "@mui/icons-material/QrCode2"; // 
import BarcodeIcon from "../../components/ui/BarcodeIcon";

const ReturnFileHeader = (props) => {

    const intl = useIntl();
    const { setLoading } = useLoading();

    const [openModalChangeReconditionType, setOpenModalChangeReconditionType] = useState(false);
    const [reconditionTypes, setReconditionTypes] = useState([]);
    const [selectedReconditionType, setSelectedReconditionType] = useState("");
    const handleOpenModalChangeReconditionType = () => setOpenModalChangeReconditionType(true);
    const handleCloseModalChangeReconditionType = () => setOpenModalChangeReconditionType(false);
    const user = useSelector((state) => state.auth.user);

    const [relatedRAData, setRelatedRAData] = useState([]);

    const [invoiceBarcodeOpen, setInvoiceBarcodeOpen] = useState(false);
    const [sapIBDBarcodeOpen, setSapIBDBarcodeOpen] = useState(false);

    const handleOpenChangeRecontionType = (e, idReconditionType) => {
      e.preventDefault();
      handleOpenModalChangeReconditionType();
      setLoading(true);
      axios
        .get("returnfiles/" + props.idReturnFileHead + "/reconditiontypes")
        .then((response) => {
          setLoading(false);
          var selectItems = [];
          if (response.data !== undefined) {
            response.data.map((x) => {
              if (x.idReconditionType == idReconditionType) {
                setSelectedReconditionType(idReconditionType);
              }
              selectItems.push({
                value: x.idReconditionType,
                text: x.description,
              });
            });
          }
          setReconditionTypes(selectItems);
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl);
        });
    };

    const handleChangeReconditionType = () => {
      if (
        selectedReconditionType !== null &&
        selectedReconditionType !== undefined &&
        selectedReconditionType !== ""
      ) {
        axios
          .put(
            "returnfiles/" + props.idReturnFileHead + "/reconditiontypes",
            selectedReconditionType,
            {
              headers: { "Content-type": "application/json" },
            }
          )
          .then((response) => {
            toast.success(
              intl.formatMessage({ id: "RADetails.ReconditionTypeChanged" })
            );
            props.callBackAftereChangeReconditionType();
            handleCloseModalChangeReconditionType();
          })
          .catch((error) => {
            setLoading(false);
            handleError(error, intl);
          });
      }
    };

    const renderChangeReconditionType = (idRFHeadRelated, idReconditionType) => {
      if (Array.isArray(relatedRAData)) {
        var children = relatedRAData.find((x) => x.sequence == "Child");
        if (
          children == undefined ||
          children == null ||
          (Array.isArray(children) &&
            children.length == 0 &&
            idRFHeadRelated == null)
        ) {
          return (
            <IconButton
              color="primary"
              size="small"
              component="label"
              onClick={(e) => handleOpenChangeRecontionType(e, idReconditionType)}
              disabled={user?.profile?.default_role == "MAGI"}
            >
              <EditIcon />
            </IconButton>
          );
        }
      }
  
      return "";
    };

    const getRelatedRA = () => {
      setLoading(true);
      axios
        .get("/returnfiles/" + props.idReturnFileHead + "/relatedreturnfiles")
        .then((response) => {
          setLoading(false);
          setRelatedRAData(response.data);
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.detail);
        });
    };

    useEffect(() => {
      getRelatedRA();
    }, []);

    let headerColor = props.withStealthFlow ? "#a9a9a9" : "white";
    let cellDisplay = "none !important";

    return (
      <Box id="header">
        <Modal
          open={openModalChangeReconditionType}
          onClose={handleCloseModalChangeReconditionType}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "30%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              boxShadow: 24,
              width: 500,
              p: 4,
              borderRadius: "5px",
            }}
          >
            <PageHeader
              title={intl.formatMessage({
                id: "RADetails.ChangeReconditionType",
              })}
            />
            <Box id="modal-modal-description" sx={{ mt: 2 }}>
              <CustomInput
                labelText={intl.formatMessage({ id: "RA.ReconditionType" })}
                type="select"
                valueRef={selectedReconditionType}
                selectItems={reconditionTypes}
                setValue={setSelectedReconditionType}
                textCol={3}
                inputCol={9}
              />
              <Button
                variant="contained"
                sx={{ width: "100%" }}
                className="apeLigthBlueBackground"
                onClick={handleChangeReconditionType}
              >
                {intl.formatMessage({ id: "General.Save" })}
              </Button>
            </Box>
          </Box>
        </Modal>

        <Card sx={{ p: 0.5, bgcolor: "#C0C0C0" }}>
          <Grid container>
            <Grid item sm={2} sx={{ borderRight: "2px solid white" }}>
              <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "RA.Key" })}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.returnFileKey}
              </Typography>
            </Grid>
            <Grid item sm={1} sx={{ borderRight: "2px solid white" }}>
              <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "RA.Date" })}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {moment(props.rfDate).format("YYYY-MM-DD")}
              </Typography>
            </Grid>
            <Grid item sm={1.1} sx={{ borderRight: "2px solid white" }}>
              <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "General.Type" })}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.rfType}
              </Typography>
            </Grid>
            <Grid item sm={1.1} sx={{ borderRight: "2px solid white" }}>
              <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "General.State" })}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.rfState}
              </Typography>
            </Grid>
            <Grid item sm={1.2} sx={{ borderRight: "2px solid white" }}>
              <Grid container>
                <Grid item sm={9}>
                  <Typography
                    variant="subtitle1"
                    sx={{ color: "white", ml: 1, lineHeight: "20px", pb: 1 }}
                  >
                    {intl.formatMessage({ id: "RA.ReconditionType" })}
                  </Typography>
                  <Typography variant="subtitle2" sx={{ ml: 1 }}>
                    {props.reconditionTypeDescr}
                  </Typography>
                </Grid>
                <Grid item sm={1} sx={{ mt: 1 }}>
                  {renderChangeReconditionType(
                    props.idRFHeadRelated,
                    props.idReconditionType,
                  )}
                </Grid>
                <Grid item sm={1}></Grid>
              </Grid>
            </Grid>
            <Grid item sm={1} sx={{ borderRight: "2px solid white" }}>
              <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "RADetails.ICTNr" })}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.ictReference}
              </Typography>
            </Grid>
            <Grid item sm={1.2} sx={{ borderRight: "2px solid white" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                  {intl.formatMessage({ id: "RADetails.InvoiceNr" })}
                </Typography>
                { props.invoiceNumber == null || props.invoiceNumber === undefined || props.invoiceNumber === "" ? "" :
                  <IconButton
                    size="small"
                    onClick={() => setInvoiceBarcodeOpen(true)}
                    sx={{ p: 0.3 }}
                  >
                    <BarcodeIcon fontSize="small" />
                  </IconButton>
                }
              </Box>

              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.invoiceNumber}
              </Typography>

              <Dialog open={invoiceBarcodeOpen} onClose={() => setInvoiceBarcodeOpen(false)}>
                <DialogContent
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src={`https://barcode.tec-it.com/barcode.ashx?data=${props.invoiceNumber}&code=Code128&translate-esc=on`}
                    alt="Barcode"
                    style={{ maxWidth: "100%" }}
                  />
                </DialogContent>
              </Dialog>
            </Grid>
            <Grid item sm={1.2} sx={{ borderRight: "2px solid white" }}>
              <Typography
                variant="subtitle1"
                sx={{ color: headerColor, ml: 1 }}
              >
                {intl.formatMessage({ id: "RADetails.RSO" })}
              </Typography>
              {!props.withStealthFlow ? (
                <Typography variant="subtitle2" sx={{ ml: 1 }}>
                  {props.saprso}
                </Typography>
              ) : (
                ""
              )}
            </Grid>

            <Grid item sm={1.2} sx={{ borderRight: "2px solid white" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                  {intl.formatMessage({ id: "RA.SapInboundDelivery" })}
                </Typography>
                { props.sapInboundDelivery === null || props.sapInboundDelivery === undefined || props.sapInboundDelivery === "" ? "" : 
                  <IconButton
                    size="small"
                    onClick={() => setSapIBDBarcodeOpen(true)}
                    sx={{ p: 0.3 }}
                  >
                    <BarcodeIcon fontSize="small" />
                  </IconButton>
                }
              </Box>

              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.sapInboundDelivery}
              </Typography>

              <Dialog open={sapIBDBarcodeOpen} onClose={() => setSapIBDBarcodeOpen(false)}>
                <DialogContent
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src={`https://barcode.tec-it.com/barcode.ashx?data=${props.sapInboundDelivery}&code=Code128&translate-esc=on`}
                    alt="Barcode"
                    style={{ maxWidth: "100%" }}
                  />
                </DialogContent>
              </Dialog>
            </Grid>
            <Grid item sm={0.5}>
              <Typography variant="subtitle1" sx={{ color: "white", ml: 1 }}>
                {intl.formatMessage({ id: "General.Peces" })}
              </Typography>
              <Typography variant="subtitle2" sx={{ ml: 1 }}>
                {props.totalPieces}
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Box>
    );
}

export default ReturnFileHeader;